import { TagsDocument, useTagFilterOptionsQuery, useTagsQuery, } from 'api/generated';
export const useTagsQueryApi = () => {
    const { data, ...rest } = useTagsQuery();
    return { data: data?.tags ?? [], ...rest };
};
export const useTagFilterOptionsQueryApi = () => {
    const { data, ...rest } = useTagFilterOptionsQuery();
    return { data: data?.tags ?? [], ...rest };
};
export const getUpdateObjectTagsBulkMutationOptions = (input) => ({
    variables: { input },
    refetchQueries: [TagsDocument],
});
export { useUpdateObjectTagsBulkMutation } from 'api/generated';
